var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseWidth2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5999 6.99551C21.5999 8.98373 17.3018 10.5955 11.9999 10.5955C6.69797 10.5955 2.3999 8.98373 2.3999 6.99551M21.5999 6.99551C21.5999 5.00728 17.3018 3.39551 11.9999 3.39551C6.69797 3.39551 2.3999 5.00728 2.3999 6.99551M21.5999 6.99551V17.7955C21.5999 19.7837 17.3018 21.3955 11.9999 21.3955C6.69797 21.3955 2.3999 19.7837 2.3999 17.7955V6.99551M21.5999 12.3955C21.5999 14.3837 17.3018 15.9955 11.9999 15.9955C6.69797 15.9955 2.3999 14.3837 2.3999 12.3955",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseWidth2);
export default __webpack_public_path__ + "static/media/database-width-2.c5c6da3e6134fa62e6753f14b6f84ada.svg";
export { ForwardRef as ReactComponent };